import { Table, Modal, Button } from "antd";
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { requestOrderList, cancelSubscription } from "@/services/api";
import { ReactComponent as CloseIcon } from "@/assets/icons/closeicon.svg";
import moment from "moment";

/**
 *
 * @param {Function} handleReloadTable 刷新父组件表格数据
 *  @param {Map} renewaloOrderData 表格数据
 * @returns
 */
const RenewalModal = forwardRef(({ handleReloadTable }, ref) => {
  /**
   * 取是否开启取消自动续费弹窗
   */
  const [modalVisible, setModalVisible] = useState(false);
  /**
   * 取消自动续费按钮loading
   */
  const [loadingRow, setLoadingRow] = useState({});
  /**
   * 是否开启取消续费成功弹窗
   */
  const [successVisible, setSuccessVisible] = useState(false);
  /**
   * 设置当前是否取消自动续费成功状态，因为订单数据有延迟，不能实时更新订单续费字段
   */
  const [cancelRenewalFlag, setCancelRenewalFlag] = useState(false);
  /**
   * 续费订单数据
   */
  const [renewaloOrderData, setRenewaloOrderData] = useState([]);
  /**
   * 表格数据loading
   */
  const [tableLoading, setTableLoading] = useState(false);

  useImperativeHandle(ref, () => {
    return {
      setRenewalModalVisible: () => {
        setModalVisible(true);
        getRenewalOrderList();
      },
    };
  });

  const columnsOptions = [
    // {
    //   title: "订单编号",
    //   dataIndex: "original_custom_oid",
    //   key: "original_custom_oid",
    //   width: 180,
    //   render: (_, option) => {
    //     return (
    //       <span style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
    //         {option.original_custom_oid}
    //       </span>
    //     );
    //   },
    // },
    {
      title: "产品名",
      dataIndex: "name",
      key: "name",
      width: 180,
    },
    {
      title: "套餐类型",
      dataIndex: "license_name",
      align: "center",
      width: 110,
      key: "license_name",
      render: (_, option) => {
        const { license_info, is_bind } = option;
        if (is_bind) {
          return "捆绑套餐";
        }
        return license_info.cycle === 0
          ? "终生套餐"
          : license_info.cycle === 1
          ? "月版套餐"
          : license_info.cycle === 3
          ? "季版套餐"
          : license_info.cycle == 12
          ? "年版套餐"
          : "其他年版套餐";
      },
    },
    {
      title: "下次续费时间",
      dataIndex: "next_bill_time",
      align: "center",
      width: 140,
      key: "next_bill_time",
      render: (_, option) => {
        if (option.next_bill_time) {
          return moment(parseInt(option.next_bill_time) * 1000).format(
            "YYYY-MM-DD"
          );
        } else {
          return "";
        }
      },
    },
    {
      title: "续费金额",
      dataIndex: "amount",
      align: "center",
      key: "amount",
      width: 106,
    },
    {
      title: "操作",
      dataIndex: "options",
      align: "center",
      width: 146,
      render: (_, option) => {
        //如果当前是续费订单才显示取消自动续费
        return option.is_renew === 1 ? (
          <Button
            className="option-btn ant-btn ant-btn-primary"
            loading={loadingRow[option.key] ? true : false}
            onClick={() => cancelRenewal(option)}
          >
            取消自动续费
          </Button>
        ) : (
          ""
        );
      },
    },
  ];

  //取消自动续费
  const cancelRenewal = async (options) => {
    setLoadingRow({
      ...loadingRow,
      [options.key]: true,
    });
    try {
      const { code } = await cancelSubscription({ order_id: options.order_id });
      if (code === 200) {
        setModalVisible(false);
        setSuccessVisible(true);
        setCancelRenewalFlag(true);
        setLoadingRow((prevLoadingRow) => {
          delete prevLoadingRow[options.key];
          return { ...prevLoadingRow };
        });
        handleReloadTable();
      }
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * 获取续费列表
   */
  const getRenewalOrderList = async () => {
    setTableLoading(true);
    let newResult = [];
    try {
      const { code, data } = await requestOrderList("niu", {
        page: 1,
        limit: 10000,
        site_id: 93,
      });
      if (code === 200 && data) {
        data.map((ele, index) => {
          ele.goods.map((item) => {
            item.order_id = ele.id;
            item.original_custom_oid = ele.original_custom_oid;
            item.is_renew = ele.is_renew;
            item.amount = ele?.renew?.amount;
            item.next_bill_time = ele?.renew?.next_bill_time;
            newResult.push({ ...item, key: index });
          });
        });
        /**
         * 过滤当前是续费订单的数据
         */
        let renewaloOrderData = newResult.filter((ele) => ele.is_renew === 1);
        setRenewaloOrderData(renewaloOrderData);
        setTableLoading(false);
        // setCancelRenewalFlag(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        title=""
        open={modalVisible}
        maskClosable={false}
        onCancel={() => setModalVisible(false)}
        footer={false}
        width={802}
        closeIcon={<CloseIcon />}
        wrapClassName="zidongxufeiModel"
        bodyStyle={{
          maxHeight: "664px",
          overflow: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="py-3 px-lg-4">
          <h4 className="text-center title mb-2 pb-1">管理自动续费</h4>
          {cancelRenewalFlag && (
            <div className="d-flex align-items-center justify-content-center mb-4">
              <img
                src="https://images.niuxuezhang.cn/imgs/account-center/warring.svg"
                alt=""
                className="me-2"
              />
              <span style={{ color: "#FF723A" }} className="small">
                由于网络波动问题，取消状态更新有所延迟，请稍后再查询是否取消成功。
              </span>
            </div>
          )}
          <Table
            columns={columnsOptions}
            dataSource={renewaloOrderData}
            pagination={{
              defaultCurrent: 1,
              total: renewaloOrderData.length,
            }}
            rowClassName={(_, index) => {
              return index % 2 === 0 ? "oddRow" : "eventRow";
            }}
            bordered
            loading={tableLoading}
          />
        </div>
      </Modal>
      <Modal
        open={successVisible}
        maskClosable={false}
        footer={false}
        onCancel={() => setSuccessVisible(false)}
        closeIcon={<CloseIcon />}
        width={508}
      >
        <div className="text-center" style={{ padding: "32px" }}>
          <picture>
            <img
              src="https://images.niuxuezhang.cn/imgs/account-center/success-icon.svg"
              alt=""
            />
          </picture>
          <div className="mt-4 pt-3" style={{ fontSize: "1rem" }}>
            自动续费取消成功
          </div>
        </div>
      </Modal>
    </>
  );
});

export default RenewalModal;
